<template>
  <div>
    <vxe-grid
      ref="techTable"
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :height="500"
      size="mini"
      border
      row-id="pdTechDictCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="$emit('remove', row)"></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          fixed: 'left',
          width: 90,
          slots: { default: 'opt' },
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_pdProcessDictStep') || '工序',
          field: 'v_pdProcessDictStep',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techName') || '工艺',
          field: 'techName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techChargeUnit') || '计价单位',
          field: 'techChargeUnitText',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
    }
  },
}
</script>
